"use client";

// Get approved app shell — Figma 8301:72996 / 8301:72998.

import { ApplicationApp } from "@/components/home/product-preview";

import { PRODUCT_WIDGET_ASSETS } from "./assets";
import { ProductWidgetFrame, ScaledProductWidgetCanvas } from "./mock-frame";

/** Step 1 app frame — inset 47px, 870.396px wide at native 1064 canvas. */
const APP_NATIVE_WIDTH = 1064;
const APP_FIGMA_WIDTH = 870.396;
const APP_SCALE = APP_FIGMA_WIDTH / APP_NATIVE_WIDTH;
const APP_OFFSET = { left: 47, top: 47 };

export function GetApprovedWidget({ className }: { className?: string }) {
  return (
    <ProductWidgetFrame className={className}>
      <ScaledProductWidgetCanvas>
        <div
          className="absolute overflow-hidden rounded-[10.313px] border-[1.333px] border-[#e5e6e6] bg-[#fbfbfb]"
          style={{
            left: APP_OFFSET.left,
            top: APP_OFFSET.top,
            width: APP_FIGMA_WIDTH,
          }}
        >
          <div
            className="origin-top-left"
            style={{
              width: APP_NATIVE_WIDTH,
              transform: `scale(${APP_SCALE})`,
            }}
          >
            <ApplicationApp compact headline="Get approved" />
          </div>
        </div>

        {/* Cursor — Figma 8301:73079 */}
        <div
          className="pointer-events-none absolute flex items-center justify-center"
          style={{
            left: 213.38,
            top: 242.15,
            width: 19.902,
            height: 22.562,
          }}
        >
          <div className="-rotate-[15deg]">
            <img
              src={PRODUCT_WIDGET_ASSETS.cursor}
              alt=""
              className="h-[19.217px] w-[15.455px]"
              aria-hidden
            />
          </div>
        </div>
      </ScaledProductWidgetCanvas>
    </ProductWidgetFrame>
  );
}
